import { resolveMonolithApiBaseUrl } from './resolveApiBaseUrl';

/** Base URL for Aura API (monolith: same host as accounts, path /api/aura/...). */
export function getAuraApiBaseUrl() {
  return resolveMonolithApiBaseUrl(
    ['REACT_APP_AURA_API_URL', 'REACT_APP_API_BASE_URL'],
    'http://localhost:8001',
  );
}

export default getAuraApiBaseUrl;
